import { render, staticRenderFns } from "./MyCollectionCategoryTree.vue?vue&type=template&id=d087e0e6&scoped=true"
import script from "./MyCollectionCategoryTree.vue?vue&type=script&lang=js"
export * from "./MyCollectionCategoryTree.vue?vue&type=script&lang=js"
import style0 from "./MyCollectionCategoryTree.vue?vue&type=style&index=0&id=d087e0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d087e0e6",
  null
  
)

export default component.exports